import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {useStoryblokFetch, filterStoryblokContentThroughGroups, sortStoryblokListContent} from '../../../utils/StoryblokFunctions';
import LoadingIndicator from '../../LoadingIndicator';

import '../../../css/storyblok-custom.css';


const StoryblokContentFetcher = ({
    params,
    render,
    nullText,
    nullRender,
    hideNullText,
    ordered,
    user
}) => {

    //for localstorage purposes, clean up params
    let localStorageSaveParams = params;
    if (localStorageSaveParams['cv']) {delete localStorageSaveParams['cv'];} if (localStorageSaveParams['token']) {delete localStorageSaveParams['token'];}

    //check if content has been fetched recently
    const prevTime = localStorage.getItem(`fetchedContent//${JSON.stringify(localStorageSaveParams)}/fetchTime`);

    const savedContent = JSON.parse(localStorage.getItem(`fetchedContent//${JSON.stringify(localStorageSaveParams)}`));
    const [data, isLoading] = useStoryblokFetch('', params, 500);

    if (!params || params === {}) {
        if (nullRender) {
            return nullRender(null);
        }
        else {
            return null;
        }
    } 

    if (isLoading) {
        if (data && data.stories) {
            return data.stories.map(dataItem => render(dataItem));
        }
        if (savedContent && savedContent.stories && savedContent.stories.length > 0) {
            return savedContent.stories.map(dataItem => render(dataItem));
        }
        if (nullRender) {
            return nullRender(null);
        }
        if (prevTime && (new Date().getTime() - prevTime)>2000.0) {
            //this is in case fetcher gets stuck in a loading animation
            if (hideNullText) {
                return null;
            }
            return (
                <div className="center">
                &nbsp;
                    <h4>{nullText}</h4>
                &nbsp;
                </div>
            );
        }
        return <LoadingIndicator color="dark" centered={true} size={24} active={isLoading}/>;
    }

    //return data
    if (data && data.stories && data.stories.length > 0) {
        //save fetch time
        if (localStorageSaveParams['cv']) {delete localStorageSaveParams['cv'];} if (localStorageSaveParams['token']) {delete localStorageSaveParams['token'];}
        localStorage.setItem(`fetchedContent/${JSON.stringify(localStorageSaveParams)}/fetchTime`, `${new Date().getTime()}`);

        // filter content based on if user has access to it or not. 
        // next, clear filtered content of null values
        let filteredContent = data.stories.map((item) => ((user) ? 
            filterStoryblokContentThroughGroups(item, user.groups) : item)).filter(element => {
            return element !== null;
        });
        // sort content by appropriate param
        filteredContent = sortStoryblokListContent(filteredContent, ordered);

        let filteredData = data;
        filteredData.stories = filteredContent;

        if (!savedContent || (savedContent !== data.stories)) {
            //save data to localStorage
            localStorage.setItem(`fetchedContent//${JSON.stringify(localStorageSaveParams)}`, JSON.stringify(data));
        }
        if (data && data.stories && data.stories.length > 0) {
            return data.stories.map(dataItem => render(dataItem));
        }
    }
    if (savedContent && savedContent.stories && savedContent.stories.length > 0) {
        return savedContent.stories.map(dataItem => render(dataItem));
    }

    // Callers that render their own content alongside this fetcher suppress the
    // placeholder, so an empty query does not print "No Content" under real content.
    if (hideNullText) {
        return null;
    }

    return (
        <div className="center">
        &nbsp;
            <h4>{nullText}</h4>
        &nbsp;
        </div>
    );

};


StoryblokContentFetcher.propTypes = {
    /**
     * Params sent
     */
    params: PropTypes.any,
    render: PropTypes.any,
    nullText: PropTypes.string,
    nullRender: PropTypes.any,
    /**
     * Suppress the "No Content" placeholder when the query returns nothing.
     * Used when the caller renders its own content alongside this fetcher.
     */
    hideNullText: PropTypes.bool,
    ordered: PropTypes.oneOf([
        'alphabet', 
        'priority',
        'time',
        'time-from-present',
    ]),
    user: PropTypes.any,
};

StoryblokContentFetcher.defaultProps = {
    params: {},
    render: null,
    nullText: "No Content",
    nullRender: null,
    hideNullText: false,
    ordered: 'alphabet',
    user: null,
};

const mapStateToProps = (state) => {
    return {
        user: state.user
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        null
    )(StoryblokContentFetcher)
);
